import {AssetSnapshot} from '@hconnect/common/types'
import {GanttChartLabel} from '@hconnect/ganttchart/src/modules'
import {dataTestId} from '@hconnect/uikit'
import {Box} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE} from '../../consts'
import {useDisplayPlantCurrency} from '../../hooks/useDisplayPlantCurrency'
import {toPixel} from '../../utils'

export interface PlanningChartLabelsProps {
  sortedAssets: AssetSnapshot[]
  hourlyPriceHeight: number
  cellHeight: number
  width: number
  shouldShowPriceInfo: boolean
  renderAssetLabel: (asset: AssetSnapshot, labelWidth: number) => React.ReactNode
}

export const PlanningChartLabels: FC<PlanningChartLabelsProps> = React.memo(
  ({sortedAssets, width, cellHeight, hourlyPriceHeight, shouldShowPriceInfo, renderAssetLabel}) => {
    const displayCurrency = useDisplayPlantCurrency()
    const numberOfAssets = sortedAssets.length
    const {t} = useTranslation(PLANNING_SCHEDULE_CHART_WIDGET_NAMESPACE)

    const labelWidth = width
    const gridTemplateRows = ((): string => {
      const priceRowTemplate = shouldShowPriceInfo ? toPixel(hourlyPriceHeight) : ''
      return `${priceRowTemplate} repeat(${numberOfAssets}, ${toPixel(cellHeight)})`
    })()
    const gridTemplateColumns = toPixel(labelWidth)

    return (
      <Box
        sx={{
          display: 'grid',
          width,
          gridTemplateRows,
          gridTemplateColumns
        }}
        {...dataTestId('planning_chart_label_container')}
      >
        {shouldShowPriceInfo && (
          <GanttChartLabel
            title={t('planning.hourlyPriceRowLabel', {currency: displayCurrency})}
            sx={{width: labelWidth, pr: 3}}
          />
        )}
        {sortedAssets?.map((asset) => (
          <React.Fragment key={asset.id}>{renderAssetLabel(asset, labelWidth)}</React.Fragment>
        ))}
      </Box>
    )
  }
)
PlanningChartLabels.displayName = 'PlanningChartLabels'
